import {
  ClientMenuItemsControllerGetAllRecommendationsApiArg,
  ClientMenuItemsControllerGetAllRecommendationsApiResponse,
} from '@/app/store/api/restApi';
import { emptyApi } from '@/app/store/api/emptyApi';

export const recommsApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getRecomms: build.query<
      ClientMenuItemsControllerGetAllRecommendationsApiResponse,
      ClientMenuItemsControllerGetAllRecommendationsApiArg
    >({
      query: ({ locationId }) => ({
        url: 'menu-items/filter/recommendations',
        params: { locationId },
      }),
      providesTags: ['MenuItems'],
    }),
  }),
});

export const { useGetRecommsQuery } = recommsApi;
